// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ouE0","content":"styles_content__23u5Q"};